import { useState } from "react";
import { useTranslation } from "react-i18next";

export default function NewsletterSection() {
  const { t } = useTranslation("home");
  const { t: tc } = useTranslation("common");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const form = e.currentTarget;
    const formData = new FormData(form);
    const hpValue = (formData.get("phone_alt") as string || "").trim();
    if (hpValue) {
      setStatus("success");
      setEmail("");
      return;
    }

    try {
      const res = await fetch("https://readdy.ai/api/form/d9qtebknlsngrm4lm5pg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email: formData.get("email") as string }).toString(),
      });
      const text = await res.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(text); } catch { /* ignore */ }
      const code = (parsed?.code as string) || "";

      if (res.ok && code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const serverMsg = (parsed?.meta as Record<string, unknown>)?.message as string
          || (parsed?.message as string)
          || "";
        if (serverMsg.includes("spam") || serverMsg.includes("form data is spam")) {
          setErrorMsg(serverMsg || tc("error"));
          setStatus("error");
        } else {
          setErrorMsg(serverMsg || tc("error"));
          setStatus("error");
        }
      }
    } catch {
      setErrorMsg(tc("error"));
      setStatus("error");
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-900 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20elegant%20abstract%20background%20with%20warm%20golden%20and%20cream%20gradients%2C%20subtle%20texture%2C%20luxurious%20fabric%20like%20waves%2C%20dreamy%20soft%20focus%2C%20editorial%20backdrop%2C%20warm%20sophisticated%20aesthetic&width=1800&height=600&seq=newsletter-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-20"
        />
      </div>
      <div className="relative w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-3">
          {t("newsletterTitle")}
        </h2>
        <p className="text-sm text-background-300 mb-8">
          {t("newsletterSubtitle")}
        </p>

        {status === "success" ? (
          <div className="bg-accent-500/20 border border-accent-500/40 rounded-lg p-4 text-background-100 text-sm">
            <i className="ri-check-line mr-2"></i>
            感谢订阅！我们会将最新的穿搭灵感发送到您的邮箱。
          </div>
        ) : (
          <form onSubmit={handleSubmit} data-readdy-form="" className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <div className="hp-field-wrapper">
              <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setStatus("idle"); }}
              placeholder={tc("emailPlaceholder")}
              required
              className="flex-1 px-4 py-3 rounded-md bg-background-800 border border-background-600 text-background-100 text-sm placeholder:text-background-400 focus:outline-none focus:border-primary-500 transition-colors"
            />
            <button
              type="submit"
              className="px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
            >
              {tc("subscribe")}
            </button>
          </form>
        )}

        {status === "error" && (
          <p className="text-accent-400 text-xs mt-3">
            {errorMsg}
          </p>
        )}
      </div>
    </section>
  );
}